<template>
  <div class="container">
    <el-dialog v-model="dialogTableVisible" title="编辑权限" width="500">
      <el-tree
          ref="treeRef"
          style="max-width: 600px"
          :data="data"
          show-checkbox
          default-expand-all
          :default-checked-keys="defaultCheckedKeys"
          node-key="id"
          highlight-current
          :props="defaultProps"
      />
      <template #footer>
        <div class="dialog-footer">
          <el-button @click.stop="handleClick">取消</el-button>
          <el-button type="primary" @click.stop="onsubmit()">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog,ElTree,ElButton} from "element-plus";
import {permission} from "../utils/storage"
export default {
  name: "perMission",
  components: {
    ElDialog,ElTree,ElButton
  },
  data(){
    return{
      defaultProps:{
        children: 'children',
        label: 'label',
        value: 'value'
      },
      dialogTableVisible:false,
      data:[],
      defaultCheckedKeys:[],
      isMounted:false
    }
  },
  beforeMount(){
    console.log(permission)
    this.data = permission
  },
  updated() {
    this.isMounted = true
  },
  methods:{

    openEdit(data){
      if (this.isMounted){
        this.$nextTick( () => {
          this.$refs.treeRef.setCheckedKeys(this.defaultCheckedKeys);
        });
      }
      let buildData = []
      for (let i in data){
        //buildData.push(data[i].id)
        if(data[i].children){
          for (let j in data[i].children){
            buildData.push(data[i].children[j].id)
          }
        }else{
          buildData.push(data[i].id)
        }
      }
      this.defaultCheckedKeys = buildData
      console.log(this.defaultCheckedKeys)
      this.dialogTableVisible=true;
    },
    closeEdit(){
      this.dialogTableVisible=false;
    },
    handleClick(){
      this.dialogTableVisible=false
      this.$emit('closeEdit')
    },
    onsubmit(){
      let temp= this.$refs.treeRef.getCheckedNodes(false,true)
      console.log(temp)
      let pre = []
      let child = {}
      //获取到1级菜单
      for(let i=0;i<temp.length;i++){
        if(temp[i].children){
          for(let j=0;j<temp[i].children.length;j++){
            child["node"+temp[i].children[j].id]=temp[i].id
          }
          let node = JSON.parse(JSON.stringify(temp[i]) )
          node.children =[]
          pre.push(node)
        }else{
          if(!child["node"+temp[i].id]){
            let node = JSON.parse(JSON.stringify(temp[i]) )
            pre.push(node)
          }
        }

      }
      console.log(pre)
      console.log(child)
      //组装子菜单
      for(let i=0;i<pre.length;i++){
        for(let j=0;j<temp.length;j++){
          if(!temp[j].children){
            if(child['node'+temp[j].id]==pre[i].id){
              pre[i].children.push(temp[j])
            }
          }
        }
      }
      console.log(pre)
      this.$emit('closeEdit',pre)
    },
  }
}
</script>
<style scoped>
.container{

}
::v-deep  .el-tree-node.is-expanded>.el-tree-node__children {
  display: flex !important;
  flex-wrap: wrap !important;
}
</style>